import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import firebase from 'utils/firebase';
import { useStoreLoginMFA } from 'stores';
import { RoutesPath } from 'routes/constants/routes-path';
import { Spinner } from 'components/core';

export const Impersonate: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const { setPassedMFA } = useStoreLoginMFA((state) => state);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (token) {
      // Clear the token from the URL and history immediately (to not appear in logs, etc.)
      window.history.replaceState({}, '', RoutesPath.noAuth.impersonate.path);

      const handleImpersonation = async () => {
        try {
          // Sign in with the custom token provided by the admin-api
          await firebase.auth().signInWithCustomToken(token);

          // Set MFA as passed to bypass local security checks
          setPassedMFA();

          // Redirect to the dashboard
          history.push(RoutesPath.pages.dashboard.path);
        } catch (err) {
          console.error('Impersonation failed:', err);
          setError(
            'Failed to log in as customer. The token may be expired or invalid.',
          );
        }
      };

      handleImpersonation();
    } else {
      setError('No impersonation token provided.');
    }
  }, [location.search, setPassedMFA, history]);

  if (error) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
        }}
      >
        <h2>Impersonation Error</h2>
        <p>{error}</p>
        <button
          type="button"
          onClick={() => history.push(RoutesPath.noAuth.signIn.path)}
        >
          Go to Login
        </button>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
      }}
    >
      <Spinner />
      <p>Logging in as customer...</p>
    </div>
  );
};
